<template lang="html">

  <article class="notificacion" :swiped="swiped" v-touch:swipe="swipe" :important="data.Importante"
    :style="(!data.leida) ? ownstyle.notificacion : ownstyle.bgWhite">
    <span class="rubbish-container" @click="borrarNotificacion">
      <rubbish class="rubbish"></rubbish>
    </span>
    <div class="contenedor-texto row-start">
      <h3 class="tipo" :style="(!data.leida) ? style.colorBasic : style.colorMediumBlack" v-html="data.titulo"></h3>
      <h4 class="texto" v-html="data.texto"></h4>
      <span class="important-mark" v-if="!data.leida"></span>
      <a class="enlace-cover" v-if="!data.urlExterna" @click="goTo(data.urlAcceso)" v-touch:swipe="swipe"></a>
      <a class="enlace-cover" v-if="data.urlExterna" :href="data.urlAcceso" target="_blank" v-touch:swipe="swipe"></a>
    </div>

  </article>

</template>

<script lang="js">


import { mapGetters, mapActions } from 'vuex'

import rubbish from '@/components/parts/icons/rubbish'

import router from '@/router';

import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents)

export default {
  name: 'notificacion',
  props: ['data'],
  data() {
    return {
      swiped: false
    }
  },
  components: {
    'rubbish': rubbish,
  },
  methods: {
    ...mapActions(['marcarNotificacionLeida', 'eliminaNotificacion']),
    borrarNotificacion: function () {
      this.eliminaNotificacion(this.data.idNotificacion);
    },
    goTo: function (url) {
      if (!this.data.urlExterna) {
        router.push('/' + url);
      } else {

      }
      this.marcarNotificacionLeida(this.data.idNotificacion).then(r => {
        if (r) {
          this.data.leida = true;
        }
      })

    },
    swipe: function (direction) {
      this.swiped = (direction == 'left');

    }
  },
  computed: {
    ...mapGetters({
      style: 'getStyles',
      colors: 'basicColors'
    }),
    ownstyle: function () {
      return {
        notificacion: {
          background: this.colors.light_black
        },
        bgWhite: {
          background: this.colors.white
        },
        mark: {
          background: this.colors.basic
        }
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/css/colors.scss';


.notificacion {
  width: 100%;
  position: relative;
}

.important-mark {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  display: inline-block;
  width: 8px;
  background: $secondary;
}

.contenedor-texto {
  width: 100%;
  padding: 20px;
  transition: .4s;
  z-index: 4;
  position: relative;
  background: #e5e5fa;
}

.notificacion:last-of-type .contenedor-texto {
  border-bottom: none !important;
}


.tipo {
  width: 120px;
  text-transform: uppercase;
  font-size: 14px;
  font-family: 'Nunito', sans-serif;
  font-weight: 700;
  margin-bottom: 0;
  text-align: left;
}

[important=true] .texto {
  font-weight: 800;
}

.texto {
  font-size: 14px;
  text-align: left;
  padding-left: 10px;
  width: calc(100% - 120px);
  font-weight: 600;
  color: $primary;
}

.rubbish-container {
  position: absolute;
  right: -19px;
  top: -20px;
  width: 20px;
  height: 20px;
  opacity: 0;
  transition: .5s;
  z-index: 7;
}

.notificacion:hover .rubbish-container {
  opacity: 1;
}

.notificacion[swiped=true] {
  .contenedor-texto {
    transform: translateX(-70px);
  }
}

@media screen and (max-width: 1024px) {
  .rubbish-container {
    opacity: 1;
    top: -10px;
    right: -10px;
    z-index: 2;
  }
}
</style>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/parts/notificacion.vue